import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const ServicesSection = ({
  services,
  OptimizedSpotlightGroup,
  OptimizedGradientCard
}) => {
  return (
    <section id="services" className="py-24 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="bg-gradient-to-r from-indigo-400 to-purple-400 bg-clip-text text-transparent">
              Our Services
            </span>
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Web development, software protection, and IT outsourcing. We build what you need.
          </p>
        </div>

        <OptimizedSpotlightGroup>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 cursor-progress">
            {services.map((service, index) => (
              <div key={index} className="spotlight-card h-full">
                <div className="spotlight-content h-full flex flex-col">
                  {/* Header */}
                  <div className="mb-4">
                    <service.icon className="h-7 w-7 text-indigo-400 mb-3" />
                    <h3 className="text-xl font-bold">{service.title}</h3>
                  </div>

                  {/* Description - grows to push image down */}
                  <p className="text-slate-300 leading-relaxed flex-grow">
                    {service.description}
                  </p>

                  {/* Image - aligned across cards */}
                  <div className="relative h-40 rounded-xl overflow-hidden my-6 flex-shrink-0">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover hover-lift"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-900/50 to-transparent" />
                  </div>

                  {/* Features - at bottom */}
                  <div className="grid grid-cols-2 gap-3 flex-shrink-0">
                    {service.features.map((feature, featureIndex) => (
                      <div key={featureIndex} className="flex items-center text-sm text-slate-400">
                        <div className="w-1.5 h-1.5 bg-indigo-400 rounded-full mr-2"></div>
                        {feature}
                      </div>
                    ))}
                  </div>

                  {service.cta && (
                    <div className="mt-6 flex-shrink-0">
                      <Link
                        to={service.cta.to}
                        className="group/link inline-flex items-center gap-2 rounded-xl border border-indigo-400/20 bg-indigo-400/10 px-4 py-2 text-sm font-semibold text-indigo-200 transition-all duration-200 hover:-translate-y-0.5 hover:border-indigo-300/40 hover:bg-indigo-400/15 hover:text-white focus-visible:border-indigo-300/60 focus-visible:bg-indigo-400/20"
                        aria-label={`${service.cta.label} for ${service.title}`}
                      >
                        {service.cta.label}
                        <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover/link:translate-x-1" />
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </OptimizedSpotlightGroup>
      </div>
    </section>
  );
};

export default ServicesSection;
